<template>
    <div class="collection">
        <div class="collection-banner">
            <div class="content">
                <div class="left">
                    <div class="titles">
                        {{ $t("title") }}
                    </div>
                    <div class="sub-titles">
                        {{ $t("subTitle") }}
                    </div>
                </div>

                <div class="right">
                    <img src="@/home/assets/img/market.png" alt="" />
                </div>
            </div>
        </div>
        <div class="collection-main">
            <div class="bread-item">
                <span class="with-hand" @click="setTempSelect">{{ $t("templates") }}</span>
                /
                <span class="primary-color">{{ $t("all") }}</span>
            </div>
            <div class="tiltes" v-if="lang !== 'en'">
                {{ $t("trendCollection") }}
            </div>
            <div class="tiltes" v-else>
                Trending
                <span class="primary-color">Collections</span>
            </div>
            <div class="tags-list">
                <div class="tags-item" v-for="i in tagList.slice(0, 4)" :key="i.id" @click="setCollectionId(i.tag_id)">
                    <div class="inline-block position-relative">
                        <img :src="i.show_photo" alt="" />
                    </div>
                </div>
            </div>
            <div class="sub-titles" v-if="lang !== 'en'">
                {{ $t("all") }}
            </div>
            <div class="sub-titles" v-else>
                All
                <span class="primary-color">Collections</span>
            </div>

            <div class="tags-list" v-if="tagList.length >= 5">
                <div class="tags-item" v-for="i in tagList.slice(4)" :key="i.id" @click="setCollectionId(i.tag_id)">
                    <div class="inline-block position-relative">
                        <img :src="i.show_photo" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";
    @Component({})
    export default class tplCollectionList extends Vue {
        value = "";
        get tagList() {
            return this.$store.state.tagList;
        }
        setTempSelect() {
            this.$store.commit("setState", {
                type: "templateSelect",
                data: "index",
            });
        }
        search() {
            this.$bus.$emit("setSearchKey", this.value);
            this.setTempSelect();
            this.value = "";
        }
        setCollectionId(data: number) {
            this.$store.commit("setState", {
                type: "templateSelect",
                data: "tagInfo",
            });
            this.$store.commit("setState", {
                type: "tagId",
                data,
            });
            this.$store.commit("setState", {
                type: "fromAllTags",
                data: true,
            });
        }
    }
</script>
<style lang="less" scoped>
    .collection {
        overflow: auto;
        .collection-banner {
            width: 100%;
            background: linear-gradient(268.44deg, #f8e6ff 0%, #dae7f6 97.53%);
            padding: 0 15px;
            .content {
                max-width: 1432px;
                width: 100%;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .left {
                    flex: 1;
                    .titles {
                        font-weight: bold;
                        font-size: 48px;
                        line-height: 72px;
                        color: #000000;
                    }
                    .sub-titles {
                        line-height: 28px;
                        font-size: 20px;
                        color: #333333;
                        margin-top: 3px;
                    }

                    .input-box {
                        border: 3px solid #000000;
                        box-shadow: 0px 25px 49px rgba(8, 37, 111, 0.1);
                        border-radius: 16px;
                        display: flex;
                        height: 88px;
                        background: #fff;
                        margin-top: 42px;
                        margin-bottom: 84px;
                        justify-content: space-between;
                        align-items: center;
                        max-width: 950px;

                        input {
                            font-size: 24px;
                            outline: none;
                            border: 0;
                            flex: 1;
                            height: 100%;
                            margin-left: 36px;
                            &::placeholder {
                                color: rgba(0, 0, 0, 0.4);
                            }
                        }
                        .box-end {
                            padding-left: 24px;
                            padding-right: 24px;
                            border-left: 1px solid #000;
                        }
                        @media screen and (max-width: 768px) {
                            margin: 20px 15px;
                            height: 68px;

                            input {
                                font-size: 16px;
                                margin-left: 16px;
                            }
                        }
                    }
                }
                .right {
                    align-self: flex-end;
                    img {
                        display: block;
                    }
                }
                @media screen and (max-width: 1500px) {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    .right {
                        display: none;
                    }
                    .left {
                        .titles {
                            padding-top: 56px;
                        }
                        .sub-titles {
                            padding: 20px 0 36px;
                        }
                    }
                }
                @media screen and(max-width: 1000px) {
                    .left {
                        .titles {
                            font-weight: bold;
                            font-size: 36px;
                            padding-top: 56px;
                            line-height: 1.2;
                            color: #000000;
                        }
                        .sub-titles {
                            line-height: 1.2;
                            font-size: 24px;
                            color: #333333;
                            margin-top: 20px;
                        }
                    }
                }
            }
        }
        .collection-main {
            max-width: 1462px;
            width: 100%;
            padding: 36px 15px 72px;
            margin: 0 auto;
            padding-top: 36px;
            .primary-color {
                color: #017fff;
            }
            .bread-item {
                font-size: 16px;
                line-height: 16px;
                color: #000000;
                span {
                    &:not(:last-child) {
                        &:hover {
                            color: #017fff;
                        }
                    }
                }
            }
            .tiltes {
                text-align: center;
                font-weight: bold;
                font-size: 36px;
                line-height: 55px;
                text-align: center;
                color: #000000;
                margin: 36px 0;
            }
            .sub-titles {
                text-align: center;
                font-weight: bold;
                font-size: 36px;
                line-height: 55px;
                text-align: center;
                color: #000000;
                margin-top: 72px;
                margin-bottom: 36px;
            }
            @media screen and(max-width: 1000px) {
                .tiltes {
                    font-size: 30px;
                    line-height: 1.2;
                }
                .sub-titles {
                    font-size: 30px;
                    line-height: 1.2;
                }
                .bread-item {
                    font-size: 14px;
                    line-height: 16px;
                    color: #000000;
                }
            }
            .description {
                font-weight: 500;
                font-size: 18px;
                line-height: 32px;
                text-align: center;
                color: #666666;
                margin-bottom: 36px;
            }
        }
    }
</style>
<i18n>
{
  "zh": {
    "title": "营销模板集合",
    "subTitle": "探索精选集，从中获得灵感",
    "templates": "模板社区",
    "all": "所有类别",
    "trendCollection": "热门类别"
  },
  "en": {
    "title": "Marketing Template Collections",
    "subTitle": "Explore Editor’s featured collections to get some inspiration from Edrawers",
    "templates": "Templates Community",
    "all": "All Collections",
    "trendCollection": "Trending Collections"
  },
  "jp": {
    "title": "使える豊富なテンプレート群",
    "subTitle": "業界に特化した豊富なテンプレートを搭載しているので、脳内イメージを高速で具現化出来ます",
    "templates": "テンプレートコミュニティ",
    "all": "すべてのカテゴリ",
    "trendCollection": "人気カテゴリ"
  },
  "fr": {
    "title": "Collections de modèles de marketing",
    "subTitle": "Explorez les collections en vedette de l'éditeur pour vous inspirer d'Edrawers",
    "templates": "Communauté des Modèles",
    "all": "Toutes les Collections",
    "trendCollection": "Collections tendance"
  },
  "de": {
    "title": "Sammlungen von Marketingvorlagen",
    "subTitle": "Entdecken Sie die von Editor vorgestellten Kollektionen, um sich von Edrawers inspirieren zu lassen",
    "templates": "Schablonen Gemeinschaft",
    "all": "Alle Sammlungen",
    "trendCollection": "Aktuelle Kollektionen"
  },
  "es": {
    "title": "Colecciones de plantillas de marketing",
    "subTitle": "Explore las colecciones destacadas del Editor para inspirarse en Edrawers",
    "templates": "Comunidad de Plantillas",
    "all": "Todas las Colecciones",
    "trendCollection": "Colecciones de Tendencias"
  },
  "pt": {
    "title": "Coleções de modelos de marketing",
    "subTitle": "Explore as coleções em destaque do Editor para se inspirar no Edrawers",
    "templates": "Comunidade de Modelos",
    "all": "Todas as coleções",
    "trendCollection": "Coleções de Tendências"
  },
  "it": {
    "title": "Raccolte di modelli di marketing",
    "subTitle": "Esplora le raccolte in primo piano di Editor per trarre ispirazione da Edrawers",
    "templates": "Comunità di Modelli",
    "all": "Tutte le Collezioni",
    "trendCollection": "Collezioni di Tendenza"
  },
  "tw": {
    "title": "營銷模板集合",
    "subTitle": "探索精選集，從中獲得靈感",
    "templates": "範本社區",
    "all": "所有類別",
    "trendCollection": "熱門類別"
  },
  "kr": {
    "title": "마케팅 템플릿 컬렉션",
    "subTitle": "컬렉션을 탐색하고 영감을 얻으십시오.",
    "templates": "템플릿 갤러리",
    "all": "모든 컬랙션",
    "trendCollection": "인기 컬랙션"
  },
  "id": {
    "title": "Koleksi Templat Pemasaran",
    "subTitle": "Jelajahi koleksi unggulan Editor untuk mendapatkan inspirasi dari para pengguna Edraw",
    "templates": "Komunitas Templat",
    "all": "Semua Koleksi",
    "trendCollection": "Koleksi yang sedang Tren"
  }
}
</i18n>
